import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BehaviorSubject } from "rxjs";
import { DevicePilomat } from "../model/devicePilomat";
import { DevicePilomatIO } from "../model/devicePilomatIO";
import { DeviceService } from "../service/device.service";
import { Log } from "../util/log";

import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from "@angular/material/dialog";
import { DeviceIosEditorComponent } from "../device-ios-editor/device-ios-editor.component";
import { DevicePilomatIOs } from "../model/devicePilomatIOs";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { AppComponent } from "../app.component";

@Component({
  selector: "app-device-ios",
  templateUrl: "./device-ios.component.html",
  styleUrls: ["./device-ios.component.css"],
})
export class DeviceIosComponent implements OnInit {
  @Input() device: DevicePilomat;
  @Input() userCanDeviceEdit: boolean;

  @ViewChild("ioloader", { static: true }) loader;
  @ViewChild("iotable", { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  // dataSource: DeviceIOSource;
  iosArray: DevicePilomatIO[] = [];

  displayedColumns: string[] = ["number", "type", "mode", "name"];

  constructor(
    private deviceService: DeviceService,
    public appComponent: AppComponent,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loadData();
    });
  }

  loadData() {
    this.loader.showLoading();

    const obs = this.deviceService.getDeviceIOs(this.device.serial);
    obs.subscribe(data => {

      this.iosArray = data;

      this.iosArray.sort((a, b) => (a.number < b.number ? -1 : 1));


      this.table.dataSource = new MatTableDataSource(this.iosArray);
      this.table.dataSource.sort = this.sort;

      this.loader.hideLoading();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

  modifyIOs(): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(DeviceIosEditorComponent, {
      width: "800px",
      data: { iosData: this.iosArray, serial: this.device.serial, version: this.device.systemInfo.version },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {
      } else if (result) {

        this.loader.showLoading();
        // Log.debug(result);

        let iosList: DevicePilomatIOs = new DevicePilomatIOs();
        iosList.ios = result.iosData;

        this.deviceService.createUpdateDeviceIOs(iosList, this.device.serial).subscribe((response) => {

          this.loader.hideLoading();

          this.loadData();

        }, (err) => {
          this.loader.hideLoading();

          if (err.error.message == "device-offline") {
            this.loadData();
            let message = $localize`:@@deviceio_device_offline_message:Il dispositivo è offline. Impossibile inviare il comando.`;
            let header = $localize`:@@deviceio_device_offline_header:Errore`;

            const scrollStrategy = this.overlay.scrollStrategies.reposition();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: '350px',
              data: { message, header },
              scrollStrategy,
            });

            dialogRef.afterClosed().subscribe((response) => {
            });
          } else if (err.error.message == "no-io-found") {
            this.loadData();
            let message = $localize`:@@deviceio_device_no_io_error_message:Nessun I/O configurato, si prega di configurare il dispositivo.`;
            let header = $localize`:@@deviceio_device_no_io_error_header:Errore`;

            const scrollStrategy = this.overlay.scrollStrategies.reposition();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: '350px',
              data: { message, header },
              scrollStrategy,
            });

            dialogRef.afterClosed().subscribe((response) => {
            });

          } else {
            this.loadData();
            let message = $localize`:@@deviceio_device_error_message:Si é verificato un errore nell'invio del comando.`;
            let header = $localize`:@@deviceio_device_error_header:Errore`;

            const scrollStrategy = this.overlay.scrollStrategies.reposition();

            const dialogRef = this.dialog.open(ConfirmDialogComponent, {
              width: '350px',
              data: { message, header },
              scrollStrategy,
            });

            dialogRef.afterClosed().subscribe((response) => {
            });

          }
        }
        );
      }
    });
  }

  isService(): boolean {
    return this.appComponent.isService();
  }
}